var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeepSafe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FB8E0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9862 28.685L39 26C36.4913 24.1175 33.375 23 30 23C26.625 23 23.5087 24.1175 21 26L30 38L32.625 34.5012V32.375C32.625 30.305 34.305 28.625 36.375 28.625C36.585 28.625 36.7837 28.655 36.9862 28.685ZM38.25 32.375C38.25 31.34 37.41 30.5 36.375 30.5C35.34 30.5 34.5 31.34 34.5 32.375V33.5C34.0875 33.5 33.75 33.8375 33.75 34.25V37.25C33.75 37.6625 34.0875 38 34.5 38H38.25C38.6625 38 39 37.6625 39 37.25V34.25C39 33.8375 38.6625 33.5 38.25 33.5V32.375ZM35.25 33.5V32.375C35.25 31.7525 35.7525 31.25 36.375 31.25C36.9975 31.25 37.5 31.7525 37.5 32.375V33.5H35.25Z",
    fill: "#FB8E0B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeepSafe);
export default __webpack_public_path__ + "static/media/keep-safe.2f0cb800902566c4e2206a082a4db8c9.svg";
export { ForwardRef as ReactComponent };